import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'FileManagement'; // Adjust the URL based on your actual API's URL

const uploadFile = async (fileFormData, folderId, mode, token) => {
    try {
        // formData.append('folderId', folderId);
        const response = await axios.post(`${API_BASE_URL}/upload`, fileFormData, {
            params: { folderId, mode },
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Failed to upload file:', error);
        return error.response
    }
};

const downloadFile = async (fileId, fileName, token) => {
    try {
        // Step 1: Get the SAS URL from the server
        const response = await axios.get(`${API_BASE_URL}/download/${fileId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        // Step 2: Use the SAS URL to download the file content
        const sasUrl = response.data;
        // const blobResponse = await axios.get(sasUrl, {
        //     responseType: 'blob'
        // });

        // // Step 3: Create a blob from the response and create a URL for it
        // const blob = new Blob([blobResponse.data]);
        // const url = window.URL.createObjectURL(blob);

        // Step 4: Create a link element and set the href to the blob URL
        const link = document.createElement('a');
        link.href = sasUrl;
        link.download = fileName;
        // link.setAttribute('download', fileName); // Set the desired file name

        // Step 5: Append the link to the body, click it to trigger the download, and remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // // Step 6: Revoke the object URL to free up memory
        // window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Failed to download file:', error);
        throw error;
    }
};


const getFileInfo = async (fileId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/info/${fileId}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch file info:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const renameFile = async (fileId, newFileName) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/rename/${fileId}`, { newFileName });
        return response.data;
    } catch (error) {
        console.error('Failed to rename file:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};


const moveItem = async (token, itemId, targetFolderId) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/moveItem`, { itemId, targetFolderId }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to move item:', error);
        throw error;
    }
};

const moveItems = async (token, itemIds, targetFolderId) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/move`, { itemIds, targetFolderId }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to move item:', error);
        throw error;
    }
};

const copyItems = async (token, itemIds, targetFolderId) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/copy`, { itemIds, targetFolderId }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to move item:', error);
        throw error;
    }
};

const deleteItems = async (token, itemIds) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/delete`, { itemIds }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to delete items:', error);
        throw error;
    }
};

const copyFile = async (fileId, newFolderId) => {
    try {
        await axios.put(`${API_BASE_URL}/copy/${fileId}`, { newFolderId });
    } catch (error) {
        console.error('Failed to copy file:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const deleteFile = async (fileId) => {
    try {
        await axios.delete(`${API_BASE_URL}/delete/${fileId}`);
    } catch (error) {
        console.error('Failed to delete file:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const listFilesAndFolders = async (mode, folderId, token) => {
    try {
        const options = {
            params: { mode, folderId },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        const response = await axios.get(`${API_BASE_URL}/list`, options);
        return response.data;
    } catch (error) {
        console.error('Failed to list files and folders:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const listSharedFilesAndFolders = async (folderId, token) => {
    try {
        const options = {
            params: { folderId },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        const response = await axios.get(`${API_BASE_URL}/listShared`, options);
        return response.data;
    } catch (error) {
        console.error('Failed to list files and folders:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const searchFilesAndFolders = async (query, mode, token) => {
    try {
        const options = {
            params: { query, mode },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        const response = await axios.get(`${API_BASE_URL}/search`, options);
        return response.data;
    } catch (error) {
        console.error('Failed to search files and folders:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const createFolder = async (folderName, parentFolderId, mode, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/createFolder`, { folderName, parentFolderId, mode }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to create folder:', error);
        throw error;
    }
};

const getUserStorage = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/userStorage`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to get user storage:', error);
        throw error;
    }
};

const shareItem = async (itemId, itemType, sharedWithUserId, sharedWithRoleId, token) => {
    try {
        const data = { itemId, itemType, sharedWithUserId, sharedWithRoleId };
        const options = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const response = await axios.post(`${API_BASE_URL}/share`, data, options);
        return response.data;
    } catch (error) {
        console.error('Failed to share item:', error);
        throw error;
    }
};

const removeShare = async (itemId, itemType, shareId, token) => {
    try {
        const options = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            data: { itemId, itemType, shareId }
        };
        const response = await axios.delete(`${API_BASE_URL}/share`, options);
        return response.data;
    } catch (error) {
        console.error('Failed to remove share:', error);
        throw error;
    }
};

const getShareInfo = async (itemId, itemType, token) => {
    try {
        const options = {
            params: { itemId, itemType },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        const response = await axios.get(`${API_BASE_URL}/share/info`, options);
        return response.data;
    } catch (error) {
        console.error('Failed to get share information:', error);
        throw error;
    }
};

export const FileManagementService = {
    uploadFile,
    downloadFile,
    getFileInfo,
    renameFile,
    moveItem,
    copyFile,
    deleteFile,
    listFilesAndFolders,
    listSharedFilesAndFolders,
    createFolder,
    moveItems,
    copyItems,
    deleteItems,
    searchFilesAndFolders,
    getUserStorage
};
